import React from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { Typography, Box } from "@material-ui/core"
import SideBox from "../../../SideBox"
// import Hashtag from "../../../Hashtag"
import Hashtags from "components/Hashtags"

const PostSettings = ({ classes, org }) => {
  return (
    <SideBox
      title={"Post Settings"}
      content={
        <Box className={classes.postSettingBoxContainer}>
          <Box>
            <Typography variant="h5" className={classes.hashtagContainer}>
              Default Hashtags
            </Typography>
          </Box>
          <Box className={classes.hashtagsArea}>
            <Box display="flex" flexWrap="wrap" id="children-pane">
              <Hashtags hashtags={org.hashtags} />
            </Box>
          </Box>
        </Box>
      }
    />
  )
}
export default withStyles(styles)(PostSettings)



// WEBPACK FOOTER //
// ./src/components/SideBox/components/PostSettings/index.jsx